export default __webpack_public_path__ + "static/media/sn.598a8741.svg";